<template>
  <div class="about">
    <TopTabbar title="关于我们" text="返回"/>
    <div class="center" v-html="content">
    </div>
  </div>
</template>

<script setup>
  import { reqPager } from '../../../API/user'
  import { onMounted,ref } from 'vue'

  const content = ref('')
  onMounted(async () => {
    const result = await reqPager({title:'关于我们'})
    if(result.code == 1) content.value = result.data[0].content
  })
</script>

<style lang="scss" scoped>
  .about{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-color: #ffffff;
    .center{
      width: 100%;
      height: calc(100% - 46px);
      overflow: auto;
      padding: 15px;
    }
  }
</style>